
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace dateUtil{

export class DateTimeHelper {
    public getTimeStamp(){
        return new Date().getTime();
    }

}

export const dateTime=new DateTimeHelper();
}